import React, { useEffect, useState } from 'react';
import { Table, Container, Spinner, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import api from '../lib/api';

function WidgetAnalyticsPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchAnalytics = async () => {
    try {
      const res = await api.get('/admin/widgets/analytics/');
      setData(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      setError('Failed to fetch analytics');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  return (
    <Container className="pt-4">
      <h4 className="mb-4">📊 Widget Analytics</h4>
      {error && <Alert variant="danger">{error}</Alert>}
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <Table bordered hover responsive size="sm" className="shadow-sm">
          <thead>
            <tr>
              <th>Widget</th>
              <th>Token</th>
              <th>Chats</th>
              <th>👍</th>
              <th>👎</th>
              <th>Last Used</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length ? (
              data.map((item) => (
                <tr key={item.token}>
                  <td>{item.site}</td>
                  <td style={{ fontSize: '0.8rem' }}>{item.token}</td>
                  <td>{item.total_chats}</td>
                  <td>{item.positive}</td>
                  <td>{item.negative}</td>
                  <td>{item.last_activity ? new Date(item.last_activity).toLocaleString() : '—'}</td>
                  <td>
                    <Link to={`/widgets/${item.token}/analytics`}>📊</Link>{' '}
                    <Link to={`/widgets/${item.token}/chats`}>💬</Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7">No data available</td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </Container>
  );
}

export default WidgetAnalyticsPage;
